import React from 'react'
import { useParams, useLocation } from 'react-router-dom'

const LevelCommissionMobile = () => {
	const { level } = useParams()
	const location = useLocation()
	const users = location.state?.users || []

	return (
		<div className='container-fluid px-3 py-4'>
			<h4 className='text-center mb-4'>Level No - {level}</h4>
			{users.length > 0 ? (
				<div className='d-flex flex-column align-items-center'>
					{users.map((user, index) => (
						<div
							key={user._id}
							className='card mb-3 w-100'
							style={{
								boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
								borderRadius: '10px',
							}}
						>
							<div className='card-body p-3'>
								<div className='d-flex justify-content-between align-items-center'>
									<h6 className='text-dark m-0'>S.NO: {index + 1}</h6>
									<span className='text-dark m-0'>Level: {level}</span>
									<span className='text-dark m-0'>Upliner Id: {user?.mainUser?.registerId}</span>
								</div>
								<div className='mt-2' style={{ display: 'flex', paddingTop: '10px' }}>
									<span>
										<img
											src={
												user?.gender === 'male'
													? 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/kal-visuals-square.jpg'
													: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/team-3.jpg'
											}
											alt='missing'
											style={{ width: '50px' }}
										/>
									</span>
									<span style={{ paddingLeft: '10px' }}>
										<p className='text-dark m-0'>User ID: {user.registerId}</p>
										<p className='text-dark m-0'>
											Referral Commissions: <sup>₹</sup>
											{Number(user.commissionAmount || 0).toFixed(2)}
										</p>
									</span>
								</div>
							</div>
						</div>
					))}
				</div>
			) : (
				<p className='text-center text-muted'>No users found for this level.</p>
			)}
		</div>
	)
}

export default LevelCommissionMobile
